import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";
import { LayoutCrudRoutes, PageClientSideFilters } from "@ryde/layout";

export const FeedbackSubjectsPage: FC = () => {
  return (
    <PageContextWrapper entity="feedbackSubject">
      <PageClientSideFilters />
      <LayoutCrudRoutes />
    </PageContextWrapper>
  );
};
